import { IApplicationState } from '../../types/redux';

export function selectLocationId(state: IApplicationState) {
  return state.buildersProjects.data.location?.id;
}
